import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/pages/Home'
import HomeForPersonal from '@/pages/HomeForPersonal'
import HomeForPrivate from '@/pages/HomeForPrivate'
import ReferGift from '@/pages/ReferGift'
import Standard from '@/pages/Standard'
import Benefit from '@/pages/Benefit'
import Draw from '@/pages/Draw'
import Examination from '@/pages/Examination'
import ProductDetail from '@/pages/ProductDetail'
import Points from '@/pages/Points'
import PointsRecord from '@/pages/PointsRecord'
import PicPage from '@/pages/PicPage'
import ExchangeRecord from '@/pages/ExchangeRecord'
import OrderDetail from '@/pages/OrderDetail'
import Salary from '@/pages/Salary'

const routes = [
  { path: '/', component: Home }, // 首页
  { path: '/homeForPersonal', component: HomeForPersonal }, // 鹏城小夏首页入口
  { path: '/homeForPrivate', component: HomeForPrivate }, // 财私部首页入口
  { path: '/referGift', component: ReferGift }, // 转介有礼
  { path: '/standard', component: Standard }, // 达标列表页
  { path: '/benefit', component: Benefit }, // 周三惠客页
  { path: '/draw', component: Draw }, // 抽奖页
  { path: '/points', component: Points }, // 积分商城页
  { path: '/examination', component: Examination }, // 健康导诊页
  { path: '/pointsRecord', component: PointsRecord }, // 积分记录页
  { path: '/productDetail', component: ProductDetail }, // 商品详情页
  { path: '/picpage', component: PicPage }, // 海报页
  { path: '/exchangeRecord', component: ExchangeRecord }, // 兑换记录页
  { path: '/orderDetail', component: OrderDetail }, // 订单详情页
	{ path: '/salary', component: Salary }, // 订单详情页
]

export default createRouter({
  // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
  history: createWebHistory(),
  routes // `routes: routes` 的缩写
})
